/* eslint-disable no-nested-ternary */
/* eslint-disable no-underscore-dangle */
import { generateTrackerLink } from '~helpers/generators';

export function getTrackerName(operator, page, path) {
  const trackerLinks = operator ? Object.keys(operator.links) : [];
  let trackerName = 'main';
  let tracker = '';
  for (let i = 0; i < trackerLinks.length; i += 1) {
    const trackerLink = trackerLinks[i].toLowerCase().replace(' ', '_');
    if (
      generateTrackerLink(operator, trackerLink, false, page.template) === path
    ) {
      tracker =
        operator.links[
          Object.keys(operator.links).find((key) => key.toLowerCase() === trackerLink.toLowerCase())
        ];
      trackerName = trackerLink.toLowerCase();
      break;
    }

    // Not sure if this code is being used or not. To check
    if (path.includes('ppc_fallback')) {
      // eslint-disable-next-line react/prop-types
      tracker = operator.links['PPC Fallback'];
      break;
    }
    tracker = operator.links.main;
  }

  return { name: trackerName, value: tracker };
}

function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

function deparam(paramStr) {
  const paramArr = paramStr.split('&');
  const paramObj = {};
  paramArr.forEach((e) => {
    const param = e.split('=');
    paramObj[param[0]] = decodeURIComponent(param[1]);
  });
  return paramObj;
}

function clean(obj) {
  for (var propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined) {
      delete obj[propName];
    }
  }
  return obj;
}

/* eslint-disable no-return-assign */
/* eslint-disable import/prefer-default-export */
export async function getAffiliateLink(operator, path, page, headers, url) {
  const trackerName = await getTrackerName(operator, page, path);

  const cookie =
    headers && headers.get('cookie')
      ? headers
          .get('cookie')
          .split(';')
          .map((item) => item.split('='))
          .reduce((acc, [k, v]) => (acc[k.trim().replace('"', '')] = v) && acc, {})
      : { affObject: JSON.stringify({}) };

  let extraURLParams = null;
  if (url && url.split('?').length === 2) {
    extraURLParams = deparam(`${url.split('?')[1]}`);
  }

  const urlParam = {
    site_id: process.env.SITE_ID,
    operator_short_name: operator.short_name,
    operator_type: operator.type,
    language: operator.market.split('_')[1],
    tracker_name: trackerName.name,
    market_short_code: operator.market,
    ip_address: headers ? headers.get('x-real-ip') || headers.get('host') : '127.0.0.1',
    user_agent: headers ? headers.get('user-agent') || headers.get('user-agent') : null,
    user_uuid: cookie ? cookie.affUUID || null : null,
    facebook_browser_id: cookie ? cookie._fbp || null : null,
    facebook_click_id: cookie ? cookie._fbc || null : null,
    split_test_name: cookie ? cookie.split_test_name || null : null,
    google_client_id:  cookie ? cookie._ga || null : null,
    split_test_variant: cookie ? cookie.split_test_variant || null : null,
    facebook_pixel_id: process.env.PIXEL_ID || null,
    ...(isJsonString(cookie.affObject) ? JSON.parse(cookie.affObject) : {}),
    ...(isJsonString(cookie.affObject) &&
    JSON.parse(cookie.affObject) &&
    !JSON.parse(cookie.affObject).referer
      ? headers
        ? headers.get('referrer')
        : null
      : {}),
    ...(extraURLParams || {}),
  };
  
  const res = await fetch(
    `${process.env.GATSBY_TRACKING_API_URL}?${new URLSearchParams(clean(urlParam)).toString()}`
  ).catch((err) => null);

  const data = res ? await res.json() : { success: false };
  return {
    props: data,
  };
}

export function getTrackingAPIParams(pageTemplate, module, tracker, clickedElement, url, referer) {
  const urlParams = {};
  let extraData = {}

  if (pageTemplate) {
    urlParams.page_type = pageTemplate;
  }
  if (module) {
    urlParams.module = module;
  }
  if (tracker !== 'main') {
    urlParams.tracker_name = tracker;
  }

  if (clickedElement) {
    urlParams.clicked_element = clickedElement;
  }

  if (referer) {
    urlParams.http_referer = referer;
  }

  if (url && url.split('?').length === 2) {
    // eslint-disable-next-line prefer-destructuring
    urlParams.request_url = url.split('?')[0];
    extraData = deparam(url.split('?')[1]);
    
    if (extraData.msclkid) {
      extraData.microsoft_click_id = extraData.msclkid;
      delete extraData.msclkid;
    }

    if (extraData.gclid) {
      extraData.google_click_id = extraData.gclid;
      delete extraData.gclid;
    }
  } else if (url) {
    urlParams.request_url = url;
  }
  
  return {...urlParams, ...extraData};
}
